import { createGlobalStyle } from 'styled-components'

function fontFace(name, fileName, fontWeight = 'normal', fontStyle = 'normal') {
  return `
    @font-face{
      font-family: ${name};
      src: url(/fonts/${fileName}.otf) format("opentype"),
      url(/fonts/${fileName}.woff) format("woff");

      font-style: ${fontStyle};
      font-weight: ${fontWeight};
    }
  `
}

export default createGlobalStyle`
  ${fontFace('elsevier-sans', 'ElsevierSansWeb-Regular', 'normal', 'normal')}
  
  body {
    font-family: elsevier-sans, Arial, Helvetica, Lucida Sans Unicode, Microsoft Sans Serif, Segoe UI Symbol, STIXGeneral, Cambria Math, Arial Unicode MS, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #ot-sdk-btn.ot-sdk-show-settings {
    
    background-color: transparent !important;
    border: 0 !important;
    border-bottom: 0.075rem solid transparent !important;
    padding: 0 !important;
    margin-left:5px;

    font-family: 'elsevier-sans'  !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 22px !important;    
    font-feature-settings: 'pnum' on, 'lnum' on !important;        
    color: #000 !important;    
}
`
